import { render } from "./ContactQuickCreate.vue?vue&type=template&id=43bf84d9"
import script from "./ContactQuickCreate.vue?vue&type=script&lang=ts"
export * from "./ContactQuickCreate.vue?vue&type=script&lang=ts"
script.render = render

export default script